import React from "react";
import { Link } from "react-router-dom";

function CallToAction({ dataContact }) {
  return (
    <div>
      <>
        {/* Start Quick contact area  */}
        <div className="quick-action-area quick-action-style-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="quick-action-inner">
                  <div className="quick-action-left">
                    <p className="description">{dataContact?.callMsg}</p>
                  </div>
                  <div className="quick-action-right">
                    <div className="contact">
                      <Link
                        className="btn-rounded mid-btn"
                        to={`tel:${dataContact?.phone}`}
                      >
                        <i className="fa-solid fa-phone-volume" />
                      </Link>
                      <div className="content">
                        <h3 className="title">{dataContact?.callTitle}</h3>
                        <Link
                          className="ph-number"
                          to={`tel:${dataContact?.phone}`}
                        >
                          {dataContact?.phone}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dot-top">
            <div className="thumbnail">
              <img src="assets/images/quick-action/1.png" alt="dot" />
            </div>
          </div>
          <div className="carly-line">
            <div className="thumbnail">
              <img src="assets/images/quick-action/carly-line.png" alt="" />
            </div>
          </div>
          <div className="dot-bottom">
            <div className="thumbnail">
              <img src="assets/images/quick-action/1.png" alt="dot" />
            </div>
          </div>
          <div className="shape">
            <div className="thumbnail">
              <img
                src="assets/images/quick-action//quick-action-1.png"
                alt="dot"
              />
            </div>
          </div>
          <div className="shape-2">
            <div className="thumbnail">
              <img src="assets/images/quick-action/shape-2.png" alt="dot" />
            </div>
          </div>
        </div>
        {/* End Quick contact area  */}
      </>
    </div>
  );
}

export default CallToAction;
